import { useLocation, useNavigate } from "react-router-dom";
import { ROUTER_PATH } from "../config/constants";

export const useNoAccountRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isNoAccountPage = location.pathname === ROUTER_PATH.noAccount;
  const setNoAccountRoute = (open: boolean) => {
    navigate(open ? ROUTER_PATH.noAccount : "/");
  };

  return {
    isNoAccountPage,
    setNoAccountRoute,
  };
};
